import { createReconTheme } from "./themeTokens";

export const lightTheme = createReconTheme("light");
